export default __webpack_public_path__ + "static/media/slice-sidebar-layers-large.d92d7306.png";